export default function Hamburger() {
    return (
        <div className="group w-10 h-10 flex flex-col justify-center items-end gap-[4px] hover:scale-110 hover:rotate-12 duration-200 p-2">
            <div className="w-6 h-[3px] bg-white group-hover:bg-red-600 rounded-full duration-200"></div>
            <div className="w-6 h-[3px] bg-white group-hover:bg-red-600 rounded-full duration-200"></div>
            <div className="w-6 h-[3px] bg-white group-hover:bg-red-600 rounded-full group-hover:w-3 duration-200"></div>
        </div>
    )
}
